import { useState, useEffect, useRef } from "react"
import { apiFetch } from '@/lib/api'
import { Textarea } from "./ui/shadcn/textarea"
import { useShow } from "@/contexts/ShowContext"
import Button from "./ui/Button"
import dayjs from "dayjs"
import { LuLoaderCircle } from "react-icons/lu"
import Loader from "./loader"

export default function CommentsEditor({ uid, onChange, elementType='asset' }) {
    const [comment, setComment] = useState('')
    const [comments, setComments] = useState([])
    const [loading, setLoading] = useState(true)
    const [posting, setPosting] = useState(false)
    const [error, setError] = useState(null)
    const { show } = useShow()
    const commentsRef = useRef(null)

    const scrollToBottom = () => {
        setTimeout(() => {
            if (commentsRef.current) {
                commentsRef.current.scrollTop = commentsRef.current.scrollHeight;
            }
        }, 0);
    }

    const fetchComments = async () => {
        try{
            const response = await apiFetch(`/api/shows/${show._id}/comments?uid=${uid}&element_type=${elementType}`)
            if(!response.ok){
                throw new Error('Failed to fetch comments')
            }

            const data = await response.json()
            setComments(data)

        }
        catch(error){
            setError(error)
        }
        finally{
            setLoading(false)
        }
    }

    useEffect(() => {
        const getComments = async () => {
            setLoading(true)
            await fetchComments()
            setLoading(false)
            scrollToBottom()
        }

        getComments()
    }, [])

    const handleSubmit = async () => {
        setPosting(true)
        try{
            const response = await apiFetch(`/api/shows/${show._id}/comments`, {
                method: 'POST',
                body: JSON.stringify({ uid, text: comment, element_type: elementType })
            })

            if(!response.ok){
                throw new Error('Failed to submit comment')
            }

            setComment('')
            await fetchComments()
            scrollToBottom()
        }
        catch(error){
            setError(error)
        }
        finally{
            setPosting(false)
        }
    }

    return (
        <div className='flex flex-col gap-4 w-full h-full relative'>
            <div className='flex flex-col gap-2 flex-1 overflow-y-auto p-4 pb-10' ref={commentsRef}>
                {comments.map((comment) => (
                    <div key={comment._id} className='flex flex-col gap-2 border bg-card rounded-md p-2'>
                        <div className='flex items-center gap-2 justify-between text-xs text-secondary-foreground/70'>
                            <div className='font-bold'>{comment.user.email}</div>
                            <div >{dayjs(comment.createdAt).format('DD/MM/YYYY HH:mm')}</div>
                        </div>
                        <div className='text-sm text-secondary-foreground whitespace-pre-wrap'>{comment.text}</div>
                    </div>
                ))}
                {posting && <div className='text-lg text-secondary-foreground flex justify-center items-center p-2'>
                    <LuLoaderCircle className="animate-spin" />
                </div>}
            </div>
            <div className={`flex gap-2 p-2 items-start ${posting ? 'opacity-50 pointer-events-none' : ''}`}>
                <Textarea value={comment} onChange={(e) => setComment(e.target.value)} />
                <Button type='primary' onClick={handleSubmit}>Submit</Button>
            </div>
            {loading && <Loader />}
        </div>
    )
}